
import TableList from "@components/templates/tablelist";
import { HttpCostList } from "@/service/boss/cost";
import { mapState, mapGetters } from "vuex";
import comIndex from './update'
export default {
    mixins: [TableList],
    components: {
        comIndex
    },
    data () {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            erpSkusList: [],
            category: '',
        }
    },
    methods: {
        ajaxRequest: HttpCostList,
        // 全部按钮点击操作
        handleOperates (params = {}, type, batch) {
            // if(type!='addnewpage'){
            //     if(batch){
            //         params=(params||this.checkedData.join(','))+'';
            //         if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            //     }
            // }
            // console.log(params)
            switch (type) {
                case "edit":
                    this.$router.push({
                        name: 'costManageUpdate',
                        params: { type: "edit" },
                        query: { jsonItem: params },
                    });
                    break;
                case "query":

                    this.operate = {
                        title: "查看",
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        jsonItem: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: '导入数据',
                        width: 460,
                        showFooter: false,
                        data: { contextId: global.SYSID },
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/ItemCost/import",
                        name: "excelFile",
                        component: "compUpload",
                        download: this.downloadExcel
                    };
                    break;
                case 'export':
                    // if (this.total > 2000) {
                    //     this.$VMessage.error('导出数据不能大于2000');
                    // } else {
                        // const formData=this.interceptRequest({search:{...this.formData.search}});
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/ItemCost/exportByFilter', {...this.formData,page: 1,
                            rows: 20000}, {
                            executor: 'request',
                            download: true,
                        }).catch(err => {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                        });
                    // }
                    break;

            }
        },
        downloadExcel () {
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/ItemCost/excel", {}, 'download')
        },
        // 操作下的列表展示内容
        getOperateNodeMap (row) {
            return [{
                label: '查看',
                show: true,
                params: row,
                operate: 'query'
            }, {
                label: '编辑',
                show: this.handleAuth('erp.cost.edit'),
                params: row,
                operate: 'edit'
            }]
        },
    },
    computed: {
        ...mapGetters('diction', ['getNewProductList', 'getAllCostGroupName', 'getAllCurrency']),
        accountsAll () {
            return this.accounts.sort(function (a, b) {
                return a.flag.localeCompare(b.flag)
            })
        },

        // 左边的批量操作按钮
        ToolsData(){
            return [
            {
                name: "批量修改",
                operate: "import",
                theme: "primary",
            },
            {
                name: "查询条件导出",
                operate: "export",
                theme: "success",
            }
            ]
        },
        // 搜索下拉框展示内容
        SearchsData () {
            const dropStyle = "width:auto;";
            return [
                {
                    label: "ERPSKU",
                    tag: 'vInput',
                    key: 'EQ_erpSku',
                    show: true,
                },

                {
                    label: "币种",
                    tag: 'vSelect',
                    key: 'EQ_currency',
                    show: true,
                    options: this.getAllCurrency,
                    props: {
                        dropStyle,
                        filterable: true,
                    }
                },

                {
                    label: "成本组名称",
                    tag: 'vSelect',
                    key: 'EQ_groupId',
                    options: this.getAllCostGroupName,
                    props: {
                        dropStyle,
                        filterable: true,
                    }
                },
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getNewProductList,
                    props: {
                        dropStyle,
                        filterable: true,
                    }
                },



            ]
        },
        // table的展示数据
        columns () {
            return [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            }, {
                title: '操作',
                width: 70,
                render: this.getOperateNodes
            },
            {
                title: '成本组名称',
                sortable: true,
                render: (h, { row }) => {
                    // getAllCostGroupName
                    const id = row.groupId;
                    const groupitem = this.getAllCostGroupName.filter((item) => {
                        return id == item.value
                    })[0] || {};
                    return <div>
                        <div>{groupitem.label}</div>
                    </div>
                }
            },
            {
                title: 'ERPSKU',
                width: 200,
                sortable: true,
                render: (h, { row }) => {
                    return <div><a onClick={this.handleOperates.bind(this, row, 'query')}>{row.erpSku}</a></div>
                }
            },

            {
                title: '项目',
                // key: 'lineId',
                sortable: true,
                render: (h, { row }) => {
                    const id = row.lineId;
                    const product = this.getNewProductList.filter((item) => {
                        return id == item.value
                    })[0] || {};
                    return <div>
                        <div>{product.label}</div>
                    </div>
                }
            },
            {
                title: '币种',
                // key: 'issueCategory',
                render: (h, { row }) => {
                    return <div>
                        <div>{row.currency}</div>
                    </div>
                },
                sortable: true
            },
            {
                renderHeader: (h, params) => {
                    return h('div', [
                        h('Tooltip', {
                            props: {
                                placement: 'top',
                                transfer: true,
                                content: '总成本=采购成本+其他成本'
                            }
                        }, [
                            h('strong', '总成本'),
                            h('Icon', {
                                props: {
                                    type: "md-help-circle",
                                    color: "#ed3f14"
                                },
                            }),
                        ]
                        )
                    ])
                },
                render: (h, { row }) => {
                    return <div>
                        <div>{row.cost}</div>
                    </div>
                }
            },
            {
                title: '采购成本',
                render: (h, { row }) => {
                    // console.log(row.itemCostDetailList,row.cost)
                    return <div>
                        <div >{row.itemCostDetailList.length>0 ? row.itemCostDetailList[0].cost : '--'}</div>
                    </div>
                }
            },
            {
                title: '其他成本',
                render: (h, { row }) => {
                    let arrlist = row.itemCostDetailList; //去除指定元素
                    const cost1 = arrlist.filter((item) => {
                        return item.costType == 1
                    })[0] || {};
                    const cost2 = arrlist.filter((item) => {
                        return item.costType == 2
                    })[0] || {};

                    return <div>
                        <div>物流成本:{cost1.cost ? cost1.cost : '--'}</div>
                        <div>税费成本:{cost2.cost ? cost2.cost : '--'}</div>
                    </div>
                    // return <div>
                    // <div>{row.assignedTo}</div>
                    // </div>
                }
            },
            {
                title: '最新更新时间',
                width: 150,
                key: 'updatedAt',
                sortable: true
            },
            ];
        },

    },

};
